// Scene
import {
  ETextParamType_OperateCanvas,
  ETextParamType_ReplaceMyAvatarIcon,
  ETextParamType_SceneItem,
  EBinaryParamType_SetGUIImage
} from './logics/const';
import {
  getCanvasLayerShow,
  setCanvasLayerShow,
  getCanvasIsPortrait,
  setCanvasIsPortrait,
  getCanvasGUIPosition,
  setCanvasGUIPosition,
  getCanvasGUIShow,
  setCanvasGUIShow
} from './logics/dataOps';
import {
  hel_canvas_SetLayoutShow,
  hel_canvas_SetGUIShow,
  hel_canvas_ResetToggleDefault,
  hel_canvas_ToggleChange,
  hel_canvas_GetLayerShow
} from './logics/gui_caller';
import {hel_setText} from './logics/moduleCaller';

declare global {
  /**
   * @remarks
   * heliodor_front.js に記述する。
   * プロジェクトにより存在しない場合もある
   */
  // eslint-disable-next-line no-var -- NOTE: TypeScriptのグローバルスコープ拡張では「var」が必須
  var hel_set_avatar_iconpath: () => void | undefined;
}

Object.assign(globalThis, {
  // OperateCanvas
  /**
   * CppとHeliScriptから参照
   */
  hel_canvas_create_html_element_byid: (
    tagName: string,
    id: string,
    parentid: string,
    style_str: string
  ) => {
    const styleJson = JSON.parse(style_str);

    const elm = document.createElement(tagName);
    if (id !== '') elm.id = id;

    // eslint-disable-next-line guard-for-in
    for (const key in styleJson) {
      // @ts-ignore
      elm.style[key] = styleJson[key];
    }

    if (parentid !== '') {
      const parentElm = document.getElementById(parentid);

      if (parentElm !== undefined && parentElm !== null) {
        parentElm.appendChild(elm);
      } else {
        document.body.appendChild(elm);
      }
    } else {
      document.body.appendChild(elm);
    }
  },

  /**
   * @remarks
   * JRWorld_web->heliodor_front.jsにて参照
   * JRWorld_web->heliodor_skyway.jsにて参照
   * XRWorldIngame->heliodor_front.jsにて参照
   * XRWorldIngame->heliodor_xrw_interface.jsにて参照
   * XRWorldIngame->heliodor_skyway.jsにて参照
   * heliodor_front, skywayから呼出があるため、global関数としておいておく
   */
  hel_canvas_SetLayoutShow,

  /**
   * @remarks
   * JRWorld_web->heliodor_front.jsにて参照
   * JRWorld_web->heliodor_skyway.jsにて参照
   * XRWorldIngame->heliodor_xrw_interface.jsにて参照
   * XRWorldIngame->heliodor_skyway.jsにて参照
   * heliodor_front, xrw_interface, skywayから呼出があるため、global関数としておいておく
   */
  hel_canvas_SetGUIShow,

  /**
   * @remarks
   * heliodor_front, xrw_interface.jsから呼出があるため、global関数としておいておく
   * @param layoutName
   * @param guiName
   */
  hel_canvas_ResetGUIPos: (layoutName: string, guiName: string) => {
    hel_setText(ETextParamType_OperateCanvas, 'ResetGUIPos,' + layoutName + ',' + guiName);
  },

  /**
   * @remarks
   * JRWorld_web->heliodor_front.jsにて参照
   * XRWorldIngame->heliodor_xrw_interface.jsにて参照
   * heliodor_front, xrw_interface, skyway, skyway_rcpから呼出があるため、global関数としておいておく
   * @param layoutName
   * @param guiName
   * @param text
   */
  hel_canvas_SetGUIText: (layoutName: string, guiName: string, text: string) => {
    hel_setText(
      ETextParamType_OperateCanvas,
      'SetGUIText,' + layoutName + ',' + guiName + ',' + text
    );
  },

  /**
   * @remarks
   * JRWorld_web->heliodor_front.jsにて参照
   * heliodor_front.jsから参照あるためglobal関数としておいておく
   * @param ItemName
   * @param NodeName
   * @param Show
   */
  hel_scene_SetShowNode: (ItemName: string, NodeName: string, Show: boolean) => {
    hel_setText(
      ETextParamType_SceneItem,
      'SetShowNode,' + ItemName + ',' + NodeName + ',' + (Show ? '1' : '0')
    );
  },

  /**
   * @remarks
   * JRWorld_web->heliodor_front.jsにて参照
   * XRWorldIngame->heliodor_xrw_interface.jsにて参照
   * heliodor_front.jsから参照あるためglobal関数としておいておく
   */
  hel_canvas_ResetToggleDefault,

  /**
   * @remarks
   * JRWorld_web->heliodor_front.jsにて参照
   * XRWorldIngame->heliodor_xrw_interface.jsにて参照
   * heliodor_front.jsから参照あるためglobal関数としておいておく
   */
  hel_canvas_ToggleChange,

  /**
   * アバターアイコンのパス情報を作る。
   * @remarks
   * hel_set_avatar_iconpath() は heliodor_front.js に記述する。
   * プロジェクトにより存在しない場合もあるが、その場合は従来どおり
   * config_avatar.json の "AvatarList" を参照して、
   * エンジンがアイコンパス情報を作る。
   *
   * JRWorld_web->heliodor_front.jsにて参照
   * XRWorldIngame->heliodor_xrw_interface.jsにて参照
   * heliodor_front, xrw_interface.jsから呼出があるため、global関数としておいておく
   */
  hel_canvas_MakeAvatarIconMap: () => {
    if (globalThis.hel_set_avatar_iconpath) {
      globalThis.hel_set_avatar_iconpath();
    }
  },

  /**
   * @remarks
   * JRWorld_web->heliodor_front.jsにて参照
   * XRWorldIngame->heliodor_xrw_interface.jsにて参照
   * heliodor_front, xrw_interface.jsから呼出があるため、global関数としておいておく
   */
  hel_canvas_ClearAvatarIconMap: () => {
    // アバターアイコンのパス情報をすべて消す
    const layoutName = 'DummyLayout'; // 構文ルール上必要
    hel_setText(ETextParamType_OperateCanvas, 'ClearAvatarIconMap,' + layoutName + ',' + 'true');
  },

  /**
   * @remarks
   * JRWorld_web->heliodor_front.jsにて参照
   * XRWorldIngame->heliodor_xrw_interface.jsにて参照
   * heliodor_front, xrw_interface.jsから呼出があるため、global関数としておいておく
   * @param AvatarId
   * @param AvatarIconPath
   */
  hel_canvas_AddAvatarIconMap: (AvatarId: string, AvatarIconPath: string) => {
    // アバターアイコンのパス情報を追加する
    const layoutName = 'DummyLayout'; // 構文ルール上必要
    hel_setText(
      ETextParamType_OperateCanvas,
      'AddAvatarIconMap,' + layoutName + ',' + AvatarId + ',' + AvatarIconPath
    );
  },

  /**
   * @remarks
   * JRWorld_web->heliodor_front.jsにて参照
   * XRWorldIngame->heliodor_xrw_interface.jsにて参照
   * heliodor_front, xrw_interface.jsから呼出があるため、global関数としておいておく
   * @param AvatarId
   * @param AvatarIconPath
   */
  hel_canvas_ReplaceAvatarIconMap: (AvatarId: string, AvatarIconPath: string) => {
    // アバターアイコンのパス情報を追加する
    const layoutName = 'DummyLayout'; // 構文ルール上必要
    hel_setText(
      ETextParamType_OperateCanvas,
      'ReplaceAvatarIconMap,' + layoutName + ',' + AvatarId + ',' + AvatarIconPath
    );
  },

  /**
   * @remarks
   * XRWorldIngame->heliodor_xrw_main.jsにて参照
   * @param newAvatarId
   */
  hel_canvas_ReplaceMyAvatarIcon: (newAvatarId: string) => {
    hel_setText(ETextParamType_ReplaceMyAvatarIcon, newAvatarId);
  },

  /**
   * @remarks
   * JRWorld_web->heliodor_front.jsにて参照
   * XRWorldIngame->heliodor_xrw_interface.jsにて参照
   * heliodor_front, xrw_interface.jsから呼出があるため、global関数としておいておく
   * @param layoutName
   * @param guiName
   * @param fileName
   */
  hel_canvas_SetGUIImage: (layoutName: string, guiName: string, fileName: string) => {
    hel_setText(
      ETextParamType_OperateCanvas,
      'SetGUIImage,' + layoutName + ',' + guiName + ',' + fileName
    );
  },

  /**
   * @remarks
   * Housing の 「画像アップロード」で使用されます。
   * guiNameのImageを textureWidth, textureHeight の
   * サイズの大きい方にテクスチャを縦横等倍でフィッティングさせ、
   * そのテクスチャの中心を起点に縦・横をカットして表示させます。
   * @param layoutName
   * @param guiName
   * @param textureWidth '256', '512', '1024' のいずれか。
   * @param textureHeight '256', '512', '1024' のいずれか。
   */
  hel_canvas_SetGUIImageUploadTextureClipping: (
    layoutName: string,
    guiName: string,
    textureWidth: string,
    textureHeight: string
  ) => {
    hel_setText(
      ETextParamType_OperateCanvas,
      'SetGUIImageUploadTextureClipping,' +
        layoutName +
        ',' +
        guiName +
        ',' +
        textureWidth +
        ',' +
        textureHeight
    );
  },

  /**
   * @remarks
   * JRWorld_web->heliodor_front.jsにて参照
   * XRWorldIngame->heliodor_xrw_interface.jsにて参照
   * heliodor_front, xrw_interface.jsから呼出があるため、global関数としておいておく
   * @param layoutName
   * @param guiName
   * @param fileName
   */
  hel_canvas_SetGUIImageResizeRequest: (
    layoutName: string,
    guiName: string,
    resizeType: string
  ) => {
    hel_setText(
      ETextParamType_OperateCanvas,
      'SetGUIImageResizeRequest,' + layoutName + ',' + guiName + ',' + resizeType
    );
  },

  /**
   * @remarks
   * heliodor_front, xrw_interface.jsから呼出があるため、global関数としておいておく
   * @param layoutName
   * @param guiName
   * @param canvasID
   */
  hel_canvas_SetGUIImageByHTMLCanvas: (layoutName: string, guiName: string, canvasID: string) => {
    hel_setText(
      ETextParamType_OperateCanvas,
      'SetGUIImageByHTMLCanvas,' + layoutName + ',' + guiName + ',' + canvasID
    );
  },

  /**
   * @remarks
   *
   * @param layoutName
   * @param guiName
   * @param ary_u8
   */
  hel_canvas_SetGUIImageByUint8Array: (layoutName: string, guiName: string, ary_u8: Uint8Array) => {
    // 先にレイヤー名とGUI名を設定しておく
    hel_setText(
      ETextParamType_OperateCanvas,
      'SetGUIImageByUint8Array,' + layoutName + ',' + guiName
    );

    // バイナリデータを送る
    hel_setBinary(EBinaryParamType_SetGUIImage, ary_u8);
  },

  /**
   * @remarks
   * heliodor_front, xrw_interface.jsから呼出があるため、global関数としておいておく
   */
  hel_canvas_GetLayerShow,

  /**
   * @remarks
   * heliodor_front, xrw_interface.jsから呼出があるため、global関数としておいておく
   * @param layoutName
   */
  hel_canvas_IsPortrait: () => {
    // エンジン側に問い合わせする。
    const layoutName = 'Dummy';
    hel_setText(ETextParamType_OperateCanvas, 'IsPortrait,' + layoutName);

    // エンジンでこの関数が呼ばれ、
    // 結果が g_CanvasIsPortrait に入る。その値を返す。
    return getCanvasIsPortrait();
  },

  /**
   * @remarks
   * heliodor_front, xrw_interface.jsから呼出があるため、global関数としておいておく
   * @param layoutName
   * @param isShow
   */
  hel_setCanvasLayerShow: (layoutName: string, isShow: boolean) => {
    // LayerのON/OFFを設定する
    // ※エンジンがこの関数を呼び出すため、JS側でこの関数を直接呼び出す事は無い。
    setCanvasLayerShow(layoutName, isShow);
  },

  /**
   * @remarks
   * heliodor_front, xrw_interface.jsから呼出があるため、global関数としておいておく
   * @param layoutName
   */
  hel_getCanvasLayerShow: (layoutName: string) => {
    // LayerのON/OFFを取得する
    return getCanvasLayerShow(layoutName);
  },

  /**
   * @remarks
   * heliodor_front, xrw_interface.jsから呼出があるため、global関数としておいておく
   * @param layoutName
   * @param isShow
   */
  hel_setCanvasIsPortrait: (isPortrait: boolean) => {
    // 縦画面・横画面のどちらの状態かを設定する
    // ※エンジンがこの関数を呼び出すため、JS側でこの関数を直接呼び出す事は無い。
    setCanvasIsPortrait(isPortrait);
  },

  /**
   * @remarks
   * heliodor_front, xrw_interface.jsから呼出があるため、global関数としておいておく
   * @param layoutName
   */
  hel_getCanvasIsPortrait: () => {
    // 縦画面・横画面のどちらの状態かを設定する
    return getCanvasIsPortrait();
  },

  /**
   * @remarks
   * @param layoutName
   * @param isShow
   */
  // ※エンジンがこの関数を呼び出すため、JS側でこの関数を直接呼び出す事は無い。
  hel_canvas_setGUIPosition: (
    layoutName: string,
    guiName: string,
    itemName: string,
    x: number,
    y: number
  ) => {
    setCanvasGUIPosition({layoutName, guiName, itemName, x, y});
  },

  /**
   * @remarks
   * @param layoutName
   * @param GUIName
   * @param ItemName
   */
  hel_canvas_getGUIPosition: (
    layoutName: string,
    guiName: string,
    itemName: string
  ): {x: number; y: number} | undefined => {
    // エンジン側に問い合わせする。
    hel_setText(
      ETextParamType_OperateCanvas,
      'GetGUIPosition,' + layoutName + ',' + guiName + ',' + itemName
    );
    // 結果が g_CanvasGUIPosition[] に入る。その値を返す。
    return getCanvasGUIPosition({layoutName, guiName, itemName: itemName});
  },

  /**
   * @remarks
   * @param layoutName
   * @param isShow
   */
  // ※エンジンがこの関数を呼び出すため、JS側でこの関数を直接呼び出す事は無い。
  hel_js_canvas_setGUIShow: (
    layoutName: string,
    guiName: string,
    itemName: string,
    show: boolean
  ) => {
    setCanvasGUIShow({layoutName, guiName, itemName, show});
  },

  /**
   * @remarks
   * @param layoutName
   * @param GUIName
   * @param ItemName
   */
  hel_canvas_getGUIShow: (
    layoutName: string,
    guiName: string,
    itemName: string
  ): {show: boolean} | undefined => {
    // エンジン側に問い合わせする。
    hel_setText(
      ETextParamType_OperateCanvas,
      'GetGUIShow,' + layoutName + ',' + guiName + ',' + itemName
    );
    // 結果が g_CanvasGUIPosition[] に入る。その値を返す。
    return getCanvasGUIShow({layoutName, guiName, itemName: itemName});
  }
});
const hel_setBinary = (
  EBinaryParamType_SetGUIImage: number,
  ary_u8: Uint8Array<ArrayBufferLike>
) => {
  throw new Error('Function not implemented.');
};
